import React, { useState } from 'react';
import {useNavigate} from 'react-router-dom';
import api from './api.js';
import { Box, Container, TextField, Button } from '@mui/material';
import Header from './components/Header.jsx';
import { useConfirmBackLogout } from './common/useConfirmBackLogout.js';
import BackButton from './common/BackButton';
import { useNavigationHistory } from "./common/navigationHistory.js";
import HamburgerMenu from './components/Hamburger.jsx';

function MailFormPage() {
  const navigate = useNavigate();

  const handleScrollTo = (id, targetUrl) => {
      if (targetUrl && window.location.pathname !== targetUrl) {
        // 別ページなら localStorage に保存して navigate
        localStorage.setItem('scrollToId', id);
        navigate(targetUrl);
      } else {
        // 同ページなら即スクロール
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
    };


  const [isHovered, setIsHovered] = useState(false);

  const pdfItems = [
      { label: 'INDEX', path: '/INDEX.pdf' },
      { label: '出展の手引き', path: '/出展の手引き.pdf' },
      { label: '各種届出提出方法', path: '/各種届出提出方法.pdf' },
      { label: '出展者証について', path: '/出展者証について.pdf' },
      { label: '出展者駐車許可証(見本)', path: '/出展者専用駐車許可証兼搬出車両証見本.pdf' },
      { label: '当日スタッフ', path: '/当日スタッフ.pdf' },
      { label: '広報宣伝計画', path: '/広報宣伝計画.pdf' },
      { label: '第1展示館の小間図面', path: '/第1展示館の小間図面.pdf' },
      { label: '出展者一覧', path: '/出展者一覧.pdf' },
      { label: '出展者へのお願い', path: '/出展者へのお願い.pdf' },
      { label: '各運送サービスのご案内', path: '/各運送サービスのご案内.zip' },
      { label: '会場内飲食のご案内', path: '/会場内飲食のご案内.pdf' },
      { label: '出展者操作マニュアル', path: '/出展者操作マニュアル.pdf' },
    ];

  const renderMenuItems = () => (
      <div
        className="menu-item"
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <div className="menu-label">資料ダウンロード</div>
        {isHovered && (
          <div className="submenu">
            {pdfItems.map((item, index) => (
              <a key={index} href={item.path} download className="submenu-item">
                {item.label}
              </a>
            ))}
          </div>
        )}
      </div>
  );

  const user = JSON.parse(localStorage.getItem("user"));

  useConfirmBackLogout(navigate);
  useNavigationHistory();

  return (
    <div>
      <Header
        title="メッセナゴヤ お問い合わせ"
      />
      <style>
        {`
        @media only screen and (max-width: 560px) {
        .sm-block {display: block;}
        .sm-none {display: none;}
        .sm-column {flex-direction: column;}
        .noti-cate {font-size: 18px;}
        .timestamp {font-size: 14px;}
        .info {font-size: 14px;}
        .f-16 {font-size: 16px;}
        .sm-w-100 {width : 100%;}
        }
        @media only screen and (min-width: 561px) {
        .hamburger_menu_btn_wrap {display: none;}
        .sm-w-100 {width: 80%;}
        }
        `}
       </style>
      <Container sx={{ display: 'flex' }}>
        {user?.role === 'exhibitor' ? (
          <>
          <Container sx={{ width: '22%', mt: 4 }} className='sm-none'>
            <Box>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                <Box
                  className="menu-item"
                  onClick={() => {
                    navigate(user?.mypage_url);
                  }}
                >
                  TOP
                </Box>
                <Box 
                  className="menu-item"
                  onClick={() => {
                    const user = JSON.parse(localStorage.getItem('user'));
                    const repId = user?.representative_id;
                    navigate(`/mypage-info/${repId}`);
                  }}
                >
                  出展者情報編集
                </Box>
                {/* <Box
                  className="menu-group"
                  id="hover-block"
                  onMouseEnter={() => {}}
                  onMouseLeave={() => {}}
                >
                  <Box className="menu-item reverse-triangle" onClick={() => setShowFormMenu(prev => !prev)}>
                    申請フォーム
                  </Box>
                    {showFormMenu && (
                      <Box className="hover-menu">
                        <Typography
                          sx={{ color: '#FF0000', textAlign: 'center',borderBottom: '1px solid #0071BC', pb: 1 }}
                          className='form-button'
                          onClick={() => navigate('/form-require')}
                        >
                          必須フォーム<br />
                          (全出展者対象)
                        </Typography>
                        <Typography
                          sx={{ color: '#0071bc', textAlign: 'center', pt: 1 }}
                          className='form-button'
                          onClick={() => navigate('/form-optional')}
                        >
                          任意フォーム<br />
                          (該当出展者対象)
                        </Typography>
                      </Box>
                    )}
                </Box> */}
                <Box 
                  className="menu-item"
                  onClick={() => {
                  navigate('/mail-form/');
                }}
                >
                  お問い合わせ
                </Box>
                {renderMenuItems()}
                <Box 
                  className="menu-item"
                  onClick={() => {
                    const user = JSON.parse(localStorage.getItem('user') || '{}');
                    const mypage = user?.mypage_url;

                    handleScrollTo('news', mypage);
                  }}
                >
                  お知らせ
                </Box>
                <Box
                  className="menu-item"
                  onClick={() => window.open('https://www.messenagoya.jp/policy/privacy', '_blank', 'noopener,noreferrer')}
                >
                  個人情報保護方針
                </Box>
              </Box>
            </Box>
            <BackButton />
          </Container>
          <HamburgerMenu />
          </>
        ) : (
          <Container sx={{ width: '20%', mt: 4 }}>
            <Box>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                <Box
                  className="menu-item"
                  onClick={() => {
                    navigate(user?.mypage_url);
                  }}
                >
                  TOP
                </Box>
                <Box
                className="menu-item"
                onClick={() => {
                const user = JSON.parse(localStorage.getItem('user'));
                const repId = user?.representative_id;
                navigate(`/corporate-mypage-info/${repId}`);
                }}
                >
                  協力会社情報編集
                </Box>
                <Box 
                  className="menu-item"
                  onClick={() => {
                    navigate('/mail-form/');
                    }}
                >
                  お問い合わせ
                </Box>
                <Box 
                  className="menu-item"
                  onClick={() => {
                    const user = JSON.parse(localStorage.getItem('user') || '{}');
                    const mypage = user?.mypage_url;

                    handleScrollTo('news', mypage);
                  }}
                >
                  お知らせ
                </Box>
              </Box>
            </Box>
          </Container>
        )}
        
        <Container sx={{ width: '80%', mt: 4}}>
          <SimpleMailForm targetType={user?.role} targetId={user?.role === 'exhibitor' ? user?.exhibitor_id : user?.representative_id} />
        </Container>
      </Container>
    </div>
  );
}

function SimpleMailForm({ targetType, targetId }) {
  const [subject, setSubject] = useState('');
  const [body, setBody] = useState('');
  const [status, setStatus] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await api.post('/api/mail/send', {
        target_type: targetType,
        target_id: targetId,
        subject,
        body,
      });
      setStatus('送信を完了しました。');
    } catch (err) {
      console.error(err);
      setStatus('送信に失敗しました。');
    }
  };

  return (
    <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 20, alignItems: 'center' }}>
      <div style={{ display: 'flex', alignItems: 'center', margin: 'auto' }} className='sm-w-100'>
        <TextField fullWidth label="件名" value={subject} onChange={(e) => setSubject(e.target.value)} required />
      </div>

      <div style={{ display: 'flex', alignItems: 'center', margin: 'auto' }} className='sm-w-100'>
        <TextField fullWidth multiline rows={10} label="本文" value={body} onChange={(e) => setBody(e.target.value)} required />
      </div>

      <Button type="submit" sx={{ border: '1px solid #0071BC'}} className='sm-w-100'>送信</Button>
      <p>{status}</p>
    </form>
  );
}

export default MailFormPage;
